import store from '@/store'
import axios from 'axios'
import _ from 'lodash'
import * as config from '@/config'
import math from '@/utils/math'
import message from '@/utils/message'
import auth from '@/utils/auth'
import shajs from 'sha.js'
import router from '@/router'
import uuid from 'uuid/v4'
import * as commonQuery from '@/queries/common'
export default {
  /**
   * api コール
   * @param {String} url
   * @param {Boolean} requireAuthCheck トークン有効期限チェック 既定は true
   * @param {String} method 既定は post
   * @param {Object} heads headers
   * @param {Object} data body
   * @param {Nnmber} timeout リクエストタイムアウト時間(ms)
   */
  async apiAxios (url, { requireAuthCheck = true, method = 'post', heads, data, params, timeout = config.REQUEST_TIMEOUT } = {}) {
    try {
      if (requireAuthCheck) {
        await auth.tokenExpiredTransitionLogin()
      }
      let headers = {
        'X-API-KEY': store.state.apiKey
      }
      // cookie を利用しない場合は Authorization にトークンをセット
      if (!config.COOKIE) {
        headers.Authorization = 'Bearer ' + store.state.token
      }
      if (heads) {
        Object.keys(heads).forEach(key => {
          headers[key] = heads[key]
        })
      }
      console.log('axios実行開始')
      console.log('method', method)
      console.log('url', url)
      console.log('config', config)
      console.log('headers', headers)
      console.log('data', data)
      console.log('params', params)
      console.log('timeout', timeout)
      const response = await axios({ method: method, url: url, withCredentials: config.COOKIE, headers, data, params, timeout })
        // トークンの有効期限内 かつ IPアドレス変更されているときのAPI呼び出し時の403エラー対応
        // ログイン画面へ遷移、セッションタイムアウトメッセージの追加
        // トークン有効期限切れ かつ リフレッシュトークン期限内のIPアドレスの変更時のリフレッシュトークンの取得時は対象外となるように「requireAuthCheck」で判定
        .catch((error) => {
          console.log('error.response', error.response, 'requireAuthCheck', requireAuthCheck)
          if (error.response && error.response.status === 403 && requireAuthCheck) {
            store.dispatch({
              type: 'set',
              states: {
                'loggedIn': false
              }
            })
            router.push({ path: '/login', query: { redirect: router.history.current.path } })
            this.addError(error, { msg: message.MSG_204() })
          }
          throw error
        })

      console.log('axios実行終了')
      return response
    } catch (error) {
      throw error
    }
  },
  /**
   * axios で GraphQL Query を POST します。
   * @param {String} query GraphQL Query
   * @param {String} endPoint  GraphQL API エンドポイント
   * @param {Nnmber} timeout リクエストタイムアウト時間(ms)
   * @return {Object} response data
   */
  async postGraphQl (query, { endPoint = config.GRAPH_QL_URL, timeout = config.REQUEST_TIMEOUT, isMessageControl = false } = {}) {
    try {
      let response = await this.apiAxios(endPoint, { data: { query: query }, timeout })
      checkGraphQlResponse(response)
      return response
    } catch (error) {
      // 呼び出しもとでメッセージの表示制御していない場合、エラーメッセージを表示する。
      if (isMessageControl === false) {
        this.addError(error, { msg: message.MSG_301() })
      }
      throw error
    }
  },
  /**
   * Object Value を toggle します。
   * @param {Object} obj   オブジェクト
   * @param {Array} array toggle 対象 / 非対象 の key 名
   * @param {Boolean} isOther array に指定された key 、又はそれ以外を対象 （true: other, false: only）
   * @param {*} fixed 指定がある場合は、fixed をセットする
   */
  toggleObjVal (obj, array = [], isOther = true, fixed = '') {
    Object.keys(obj).forEach((key) => {
      if (isOther) {
        if (array.indexOf(key) < 0) {
          if (fixed === '') {
            obj[key] = !obj[key]
          } else {
            obj[key] = fixed
          }
        }
      } else {
        if (array.indexOf(key) >= 0) {
          if (fixed === '') {
            obj[key] = !obj[key]
          } else {
            obj[key] = fixed
          }
        }
      }
    })
  },
  /**
   * ? を object の key value に replace します。
   * @param {String} query query
   * @param {Object} obj object
   * @return {String}
   */
  addGraphQlCondition (query, obj) {
    let strWhere = ''
    Object.keys(obj).forEach((key, index) => {
      if (index > 0) {
        strWhere += ', '
      }
      let val = ''
      if (typeof obj[key] === 'string') {
        val = _.chain(obj)
          .get(key)
          .replace(/\\/g, '\\\\')
          .replace(/"/g, '\\"')
          .replace(/\//g, '\\/')
          .thru(val => `"${val}"`)
          .value()
      } else if (Array.isArray(obj[key])) {
        let array = _.chain(obj[key])
          .reduce((acc, cur) => {
            acc.push(typeof cur === 'string' ? `"${cur}"` : cur)
            return acc
          }, [])
          .join(',')
          .value()
        val = `[${array}]`
      } else {
        val = obj[key]
      }
      strWhere += key + ':' + val
    })
    return query.replace('?', strWhere)
  },
  /**
   * 一覧の検索条件を localStorage から復元します。
   * @param {String} localStorageKey ローカルストレージのキー
   * @param {Object} conditions 検索条件 store オブジェクト
   * @param {String} searchKeyword テキスト検索 store path
   * @param {String} isAndSearch テキスト検索AND検索有無 store path
   * @param {String} maxGetCount 最大取得件数 store path
   */
  recoverSearchConditions (localStorageKey, conditions, searchKeyword, isAndSearch, maxGetCount) {
    const jsObj = this.getLocalStorage(localStorageKey)
    if (jsObj) {
      Object.keys(jsObj).forEach(mainKey => {
        if (mainKey === 'keyword') {
          // テキスト検索 キーワード
          store.dispatch({
            type: 'set',
            states: {
              [searchKeyword]: jsObj[mainKey].value
            } })
        } else if (mainKey === 'isAndSearch') {
          // AND検索有無
          store.dispatch({
            type: 'set',
            states: {
              [isAndSearch]: jsObj[mainKey].value
            } })
        } else if (mainKey === 'maxGetCount') {
          // 最大取得件数
          store.dispatch({
            type: 'set',
            states: {
              [maxGetCount]: jsObj[mainKey].value
            } })
        } else {
          Object.keys(jsObj[mainKey]).forEach(subKey => {
            // key 存在チェック
            if (conditions.hasOwnProperty(mainKey)) {
              let val = jsObj[mainKey][subKey]
              if (subKey === 'value' && conditions[mainKey].type === 'MultiSelector') {
                val = this.removeUnknownValue(val, conditions[mainKey].options)
              }
              // 検索条件コミット
              store.dispatch({
                type: 'setValue',
                states: {
                  target: conditions[mainKey],
                  key: [subKey],
                  value: val
                } })
            } else {
              // TODO Keyが存在しない場合はローカルストレージから削除する
            }
          })
        }
      })
    }
  },
  /**
   * 検索条件を localStorage に保存します。
   * @param {String} localStorageKey ローカルストレージのキー
   * @param {String} keyword 検索キーワード
   * @param {Boolean} Search AND検索有無
   * @param {Object} state searchCondition
   */
  saveSearchConditions (localStorageKey, keyword, isAndSearch, state, maxGetCount) {
    let saveState = {}
    saveState['keyword'] = { value: keyword }
    saveState['isAndSearch'] = { value: isAndSearch }

    // 取得件数の権限があるときだけ、取得件数の保存を行う
    if (maxGetCount) saveState['maxGetCount'] = { value: maxGetCount }

    Object.keys(state).forEach(mainKey => {

      // キーワード、AND検索 は別管理のため、スキップ
      if (['keyword', 'isAndSearch'].includes(mainKey)) return
      // 非表示の場合は value をクリアする
      if (state[mainKey]['display'] === false) {
        // MultiSelector エラー回避(配列型必須)
        // ※ render タイミングでは MultiSelector が勝手に value を配列にしている
        switch (state[mainKey]['type']) {
          case 'MultiSelector':
            state[mainKey]['value'] = []
            break
          default :
            state[mainKey]['value'] = ''
            break
        }
      }
      saveState[mainKey] = {}
      saveState[mainKey].display = state[mainKey].display
      saveState[mainKey].value = state[mainKey].value
    })
    const jsonState = JSON.stringify(saveState)
    this.setLocalStorage(localStorageKey, jsonState)
  },
  /**
   * object から prop のパスにある値を取得する.
   * prop に[.] を含む場合は [.] 区切りでパスを設定します。
   * @param {Object} object
   * @param {String} prop プロパティパス
   * @return {Object}
   */
  getValueByPath: function f (object, prop) {
    prop = prop || ''
    if (!object) {
      return ''
    }
    let i = prop.indexOf('.')
    if (i < 0) {
      return object[prop]
    }
    return f(object[prop.substr(0, i)], prop.substr(i + 1))
  },
  /**
   * UUID(v4)
   */
  generateUuid () {
    let chars = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.split('')
    for (let i = 0, len = chars.length; i < len; i++) {
      switch (chars[i]) {
        case 'x':
          chars[i] = math.multiply([Math.random(), 16], math.FLOOR, 0).toString(16)
          break
        case 'y':
          chars[i] = math.add([math.multiply([Math.random(), 4]), 8], math.FLOOR, 0).toString(16)
          break
      }
    }
    return chars.join('')
  },
  /**
   * エラーオブジェクトに CCS 画面表示用メッセージを追加する
   * 既にメッセージがセットされている場合は上書きしない。
   *
   * @param {Object} error error オブジェクト
   * @param {String} msg エラーメッセージ(画面の表示に使用)
   * @param {String} title エラータイトル(画面の表示に使用)
   * @param {Boolean} [canIgnore=false] 無視できる例外の場合、true.
   */
  addError (error = {}, { msg, title, canIgnore = false }) {
    if (!Array.isArray(error.ccsErrors)) {
      error.ccsErrors = []
    }
    error.ccsErrors.push({ message: msg, title: title, canIgnore: canIgnore })
  },

  /**
   * ローカルストレージのデータを保存する（アカウントごとに保存）
   * @param {String} localStorageKey ローカルストレージに保存するデータのKey
   * @param {String} jsonState ローカルストレージに保存するデータ
   */
  async setLocalStorage (localStorageKey, data) {
    let saveState = {}
    let dt = Date.now() + config.LOCAL_STORAGE_EXPIRATION_DAYS * 1000 * 60 * 60 * 24
    saveState['LocalStorageExpiration'] = dt
    saveState['data'] = isJSON(data) ? JSON.parse(data) : data
    const jsonState = JSON.stringify(saveState)

    localStorage.setItem(localStorageKey + this.getUserUniqueKey(), jsonState)
  },
  /**
   * ローカルストレージのデータを取得する
   * @returns values 指定したKeyに紐づくローカルストレージデータ
   */
  getLocalStorage (localStorageKey) {
    try {
      const localStorageData = localStorage.getItem(localStorageKey + this.getUserUniqueKey())
      const jsObj = JSON.parse(localStorageData)
      return jsObj['data']
    } catch (exception) {
      return null
    }
  },
  /**
   * ローカルストレージのキーとして使用するアカウントごとに一意な値を取得する
   * @returns values アカウントごとに一意な、ローカルストレージに保存する際のキーの値.
   */
  getUserUniqueKey () {
    // アカウントのuuidを「sha512」でハッシュ化
    const shaKey = shajs('sha512').update(store.state.accountUuid).digest('hex')
    return shaKey
  },
  /**
   * 一意なハッシュを取得
   * @returns ハッシュ
   */
  getUniqueKey () {
    // アカウントのuuidを「sha512」でハッシュ化
    const shaKey = shajs('sha512').update(uuid() + store.state.accountUuid).digest('hex')
    return shaKey
  },
  /**
   * 最終更新日時によるAPI失敗かの判定
   * @returns ハッシュ
   */
  hasLastUpdatedError (error) {
    const code = _.get(error, 'response.data.code')
    if (code !== 400) {
      return false
    }

    return _.chain(error)
      .get('response.data.errors')
      .find(val => val.location === 'lastUpdatedAt' && val.reason === 'invalid')
      .value() != null
  },
  /**
   * エラーとなったパスワードポリシーに紐づくメッセージを取得
   * @param {string} errors エラーとなったパスワードポリシーの配列にした際ののインデックス
   * @returns values エラーとなったパスワードポリシーのメッセージ（複数ある場合は改行区切り）
   */
  getPasswordPolicyErrorMessage (errors) {
    let outputMessageArray = []
    const passwordPolicies = store.getters['getServiceSiteConfig'](0, 'm_account', 'password', 'policy')

    let errorMessages = []
    if (passwordPolicies) {
      errorMessages = passwordPolicies.v[1].split(/\\r\\n|\\n/)
    }

    let indexArray = errors.split(',')

    indexArray.forEach((index) => {
      if (index === '-1') {
        outputMessageArray[outputMessageArray.length] = '・アカウント名と異なるものを設定してください。'
      } else {
        outputMessageArray[outputMessageArray.length] = '・' + errorMessages[index]
      }
    })
    return outputMessageArray.join('\r\n')
  },
  /**
   * パスワードポリシーによるチェックを行い結果を返す
   * @param {string} account パスワードチェックを行う際のアカウント名
   * @param {string} password パスワードチェックを行う際のパスワード
   * @returns values パスワードポリシーを満たす場合、true。エラーとなったパスワードポリシーがある場合、falseと対象のパスワードポリシーのインデックスを返す
  */
  checkPasswordPolicyResult (account, password) {
    const passwordPolicies = store.getters['getServiceSiteConfig'](0, 'm_account', 'password', 'policy')
    let errorIndexes = []
    if (passwordPolicies) {
      const policies = passwordPolicies.v[0].split(/\\r\\n|\\n/)
      for (let i = 0; i < policies.length; i++) {
        if (!RegExp(policies[i]).test(password)) {
          errorIndexes[errorIndexes.length] = i
        }
      }
    }

    if (password === account) {
      errorIndexes[errorIndexes.length] = -1
    }

    if (errorIndexes.length !== 0) {
      return { valid: false, data: errorIndexes.join(',') }
    }
    return true
  },
  /**
   * file download
   * @param {*} data データ
   * @param {String} contentType コンテンツタイプ
   * @param {String} fineName ファイル名
   */
  fileDownload (data, contentType, fineName) {
    const blob = new Blob([data], { type: contentType })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = fineName
    link.click()
  },
  /**
   * テーブル表示用配列の並び替えを行います。
   * @param {[Object]} dataArray
   * @param {Object} sort
   * @returns {[Object]} 並び替え後配列
   */
  sortListData (dataArray, sort) {
    const returnArray = _.cloneDeep(dataArray)
    let order = sort.order
    switch (order) {
      case 'ascending':
        order = 'asc'; break
      case 'descending':
        order = 'desc'; break
      default:
        break
    }
    if (!sort.prop && sort.sortBy) {
      return _.orderBy(returnArray, (item) => sort.sortBy(item), [order])
    }
    return _.orderBy(returnArray, [sort.prop], [order])
  },
  /**
   * 通貨記号を付与して文字列を返します。
   * @param {String} value
   * @param {String} currency
   * @returns {String} 通貨記号を付与した文字列
   */
  concatCurrency (value, currency) {
    // 小数点以下の不要な0を削除するためfloatに一度変換
    value = parseFloat(value)
    switch (currency) {
      case 'JPY': // 日本円
        return '¥' + currencySeparator(value, true)
      case 'USD': // アメリカ・USドル
        return '$' + currencySeparator(value, true)
      case 'EUR': // ユーロ
        return '€' + currencySeparator(value, false)
      case 'AUD': // オーストラリア・ドル
        return 'A$' + currencySeparator(value, true)
      case 'CAD': // カナダ・ドル
        return 'C$' + currencySeparator(value, true)
      case 'CHF': // スイス・フラン
        return 'SFr' + currencySeparator(value, true)
      case 'DKK': // デンマーク・クローネ
        return 'Kr' + currencySeparator(value, false)
      case 'GBP': // UKポンド
        return '£' + currencySeparator(value, true)
      case 'HKD': // 香港・ドル
        return 'HK$' + currencySeparator(value, true)
      case 'NOK': // ノルウェー・クローネ
        return 'kr' + currencySeparator(value, false)
      case 'NZD': // ニュージーランド・ドル
        return 'NZ$' + currencySeparator(value, true)
      case 'SEK': // スウェーデン・クローネ
        return currencySeparator(value, false) + 'Kr'
      case 'SGD': // シンガポール・ドル
        return 'S$' + currencySeparator(value, true)
      case 'CNY': // 人民元
        return '¥' + currencySeparator(value, true)
      case 'KRW': // 韓国（大韓民国）・ウォン
        return '₩' + currencySeparator(value, true)
      default: return value
    }
  },
  /**
   * DBから一覧の表示項目を取得し、テーブルセットリストを更新します。
   * @param {String} functionKey 機能キー
   * @returns {Array} 表示項目設定配列
   */
  async getDisplayConfigs (functionKey) {
    const query = this.addGraphQlCondition(commonQuery.GRAPH_QL_QUERY_DISPLAY_CONFIG, { functionKey })
    const res = await this.postGraphQl(query)

    return _.get(res, 'data.data.displayItemConfigs.edges', []).map((data) => data.node)
  },
  /**
   * DBから一覧の表示項目を取得し、テーブルセットリストを更新します。
   * @param {String} functionKey 機能キー
   * @returns {Array} 表示項目設定配列
   */
  async getDisplayItems (functionKey) {
    const query = this.addGraphQlCondition(commonQuery.GRAPH_QL_QUERY_DISPLAY_ITEMS, { functionKey })
    const res = await this.postGraphQl(query)

    const returnValue = _.get(res, 'data.data.displayItems', []).map((data) => {
      return {
        uuid: data.uuid,
        itemKey: data.itemKey,
        attributeProperty: data.attributeProperty,
        attributeDisplayName: data.attributeDisplayName,
        isAttribute: data.attributeProperty !== null,
        isDisplay: Boolean(data.isDefaultDisplay),
        displayOrder: data.displayOrder
      }
    })
    this.recoverDisplay(functionKey, returnValue)

    return returnValue
  },
  /**
   * ローカルストレージに設定されている表示項目設定を取得し、テーブルセットリストを更新します。
   * @param {String} functionKey 機能キー
   * @param {Object} tableSetList テーブルセットリスト
   */
  recoverDisplay (functionKey, tableSetList) {
    const jsObj = this.getLocalStorage(`${functionKey}DisplayItem`)
    if (jsObj) {
      tableSetList.forEach((item) => {
        item.isDisplay = jsObj.includes(item.itemKey)
      })
    }
  },
  /**
   * 表示項目設定を localStorage に保存します。
   * @param {String} functionKey 機能キー
   * @param {Boolean} tableSetList テーブルセットリスト
   */
  saveDisplay (functionKey, tableSetList) {
    let saveState = []
    tableSetList.filter((data) => data.isDisplay).forEach(data => {
      // 非表示の場合は value をクリアする = ''
      saveState.push(data.itemKey)
    })
    const jsonState = JSON.stringify(saveState)
    this.setLocalStorage(`${functionKey}DisplayItem`, jsonState)
  },
  /**
   * 文字数を算出する関数
   * @param {*} str 文字列
   * @returns {Int} 文字数
   */
  getLen (str) {
    let result = 0
    for (let i = 0; i < str.length; i++) {
      const chr = str.charCodeAt(i)
      if ((chr >= 0x00 && chr < 0x81) ||
        (chr === 0xf8f0) ||
        (chr >= 0xff61 && chr < 0xffa0) ||
        (chr >= 0xf8f1 && chr < 0xf8f4)) {
        // 半角文字の場合は1を加算
        result += 1
        // それ以外の文字の場合は2を加算
        result += 2
      }
    }

    // 結果を返す
    return result
  },

  /**
   * DBから一覧の検索条件設定を取得する。
   * @param {String} functionKey 機能キー
   * @returns {Array} 表示項目設定配列
   */
  async getSearchConditionConfigs (functionKey) {
    const query = this.addGraphQlCondition(commonQuery.GRAPH_QL_QUERY_SEARCH_CONDITION_CONFIG, { functionKey })
    const res = await this.postGraphQl(query)

    return _.get(res, 'data.data.searchConditionConfigs.edges', []).map((data) => data.node)
  },

  /**
   * 検索条件からマスタに存在しない値を削除する.
   * @param {Array} values
   * @param {Array} options
   * @returns values からマスタに存在しない値を削除したArray.
   */
  removeUnknownValue (values, options) {
    let val = []
    if (Array.isArray(values) && values.length > 0 &&
        Array.isArray(options) && options.length > 0) {
      values.forEach(element => {
        if (options.find(option => option.code === element)) {
          val.push(element)
        }
      })
    }
    return val
  }

}

/**
 * オブジェクトがJSONオブジェクトであるか判別します。
 * @param {object} arg
 * @returns boolean JSONオブジェクトかどうかを返す。
 */
function isJSON (arg) {
  arg = (typeof arg === 'function') ? arg() : arg
  if (typeof arg !== 'string') {
    return false
  }
  try {
    arg = JSON.parse(arg)
    return true
  } catch (e) {
    return false
  }
}

const currencySeparator = function (val, isComma) {
  if (isComma) {
    // USD,JPYなど
    let split = _.split(val, '.')
    split[0] = split[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    return split.join('.')
  } else {
    // EURなど
    let split = _.split(val, ',')
    split[0] = split[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.')
    return split.join(',')
  }
}

/**
 * GraphQl のレスポンスデータにエラーがないかを確認する。エラーがある場合、throwする。
 * @param {object} responseData
 */
function checkGraphQlResponse (responseData) {
  let errors = []
  let index = 0

  if (responseData.data.errors) {
    let newError = ''
    responseData.data.errors.forEach((data) => {
      newError = JSON.stringify(data)

      errors[index] = newError + '\n'
      index++
    })
    throw new Error('GraphQLの実行でエラーが発生しました。' + errors.join())
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js